// Customizer const
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSE_MENU";
export const WINDOW_WIDTH = "WINDOW-WIDTH";
export const SWITCH_LANGUAGE = "SWITCH-LANGUAGE";

//Contact Module const
export const FETCH_START = "fetch_start";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";

//Auth const
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNIN_USER_DATA_SUCCESS = "SIGNIN_USER_DATA_SUCCESS";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const INIT_URL = "INIT_URL";

// EntityPaymnet const
export const FETCH_ENTITY_DATA = "FETCH_ENTITY_DATA";
export const FETCH_WEBSITE_DATA = "FETCH_WEBSITE_DATA";
export const ALL_WEBSITE_DATA = "ALL_WEBSITE_DATA";
export const ACTIVE_TAB = "ACTIVE_TAB";
export const ENTITY_ACTION_TYPE = "ENTITY_ACTION_TYPE";
export const SOUND_ON_OFF = "SOUND_ON_OFF";

// Payment Gateway Const
export const FETCH_PAYMENT_GATEWAY = "FETCH_PAYMENT_GATEWAY";
export const FETCH_TRANSACTION_TYPE = "FETCH_TRANSACTION_TYPE";

// Website Const
export const WEBSITE_ACTION_TYPE = "WEBSITE_ACTION_TYPE";
export const FETCH_VENDOR_DATA = "FETCH_VENDOR_DATA";
export const FETCH_ASSIGN_VENDOR_DATA = "FETCH_ASSIGN_VENDOR_DATA";

//Button Disable const
export const ENABLE_BUTTON = "ENABLE_BUTTON";

//Bank Account const
export const ACTIVE_BANK_TAB = "ACTIVE_BANK_TAB";
export const BANK_ACCOUNT = "BANK_ACCOUNT";

//Bank Account const
export const FETCH_TRANSACTION_TYPE_TAB = "FETCH_TRANSACTION_TYPE_TAB";

//Crypto Network const
export const ADD_COIN_DATA = "ADD_COIN_DATA";
export const SET_NETWORK_ACTIVE_TAB = "SET_NETWORK_ACTIVE_TAB";
export const SET_NETWORK_DETAILS = "SET_NETWORK_DETAILS";
export const SET_NETWORK_TRANSACTION_TYPE = "SET_NETWORK_TRANSACTION_TYPE";
